// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__2-NB_","footer":"footer__BZlfI","column":"column__3e4kT","columnLeft":"columnLeft__1-y0r","title":"title__1w-Kn","social":"social__1MX3u","roles":"roles__3mFOO","role":"role__1Li2P","copyright":"copyright__1ObzY","copyrightM":"copyrightM__1C_Ov"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/style.styl
// module id = uE+6
// module chunks = 0